import test from './components/test';

document.addEventListener(
  'DOMContentLoaded',
  () => {
    test();
  },
  false
);
